module.exports = "../dist/img/img_4-21.3a28.jpg";